export default __webpack_public_path__ + "static/media/messages.f9c3af87.svg";